/* eslint-disable camelcase */
export default {
  title: "Transfer to youzan",
  button_reset: 'Reset',
  label_src_balance: "Balance",
  label_dst_balance: "Youzan Balance",
  label_debit_amount: "Debit amount",
  error_not_number: "Amount must be a number",
  error_amount_required: "Amount is required",
  transfer_success: "Transfer successful",
  button_transfer_to_youzan: "Transfer to youzan",
  button_transfer_from_youzan: "Transfer from youzan",
};
